import { Table } from '@octano/global-ui';
import { ColumnTable } from '@octano/global-ui/dist/components/Table/types/TableTypes';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';

import {
  sectionListType,
  SectionScheduleTypeEnum,
} from '../types/TeacherSchedule';

import sortSectionSchedule from '../../../utils/sortSectionSchedule';
import { useTeacherScheduleLoader } from '../provider/TeacherScheduleLoader';
import { useSectionsColumns } from '../hooks/useSectionsColumns';
import { useSectionDetailsColumn } from '../hooks/useSectionDetailsColumn';
import { TranslationsKeys } from '../../../locales/translations';

const CoursesInfo = () => {
  const { t } = useTranslation(TranslationsKeys.TEACHER_SCHEDULE);
  const { data: coursesInfo } = useTeacherScheduleLoader();
  const [sectionList, setSectionList] = useState<sectionListType[]>([]);
  const [sectionDetail, setSectionDetail] = useState<sectionListType[]>();
  const [columns, setColumns] = useState<ColumnTable<any>[]>([]);
  const [data, setData] = useState<any>(undefined);
  const [hasHeader, setHasHeader] = useState<boolean>(false);

  const sectionsColumns = useSectionsColumns({
    setSectionDetail,
  });

  const goBack = useCallback(() => {
    setData(sectionList);
    setColumns(sectionsColumns);
    setHasHeader(false);
  }, [sectionList, sectionsColumns]);

  const sectionDetailsColumn = useSectionDetailsColumn({
    goBack,
  });

  useEffect(() => {
    if (coursesInfo) {
      const auxList: sectionListType[] = [];
      coursesInfo.forEach((course) => {
        const schedules = course.sectionData.sectionSchedules
          .filter(
            (schedule) => schedule.type === SectionScheduleTypeEnum.Default,
          )
          .map((schedule) => ({
            day: schedule.day,
            classroom: schedule.classroom?.name || '',
            startHour: schedule.startModule.startTime,
            endHour:
              schedule.endModule?.endTime || schedule.startModule.endTime,
          }));
        auxList.push({
          sectionName: course.sectionData.name,
          courseName: course.course.name,
          teachers: course.sectionData.professors.map(
            (teacher) => teacher?.account?.fullName,
          ),
          schedules: sortSectionSchedule(schedules),
        });
      });
      setSectionList(auxList);
    }
  }, [coursesInfo]);

  useEffect(() => {
    goBack();
  }, [goBack]);

  useEffect(() => {
    if (sectionDetail) {
      setData(sectionDetail);
      setColumns(sectionDetailsColumn);
      setHasHeader(true);
    }
  }, [sectionDetail, setData, setColumns, setHasHeader, sectionDetailsColumn]);

  return sectionList.length === 0 ? (
    <></>
  ) : (
    <Row>
      <Col xs={12}>
        <p className="fs-20 text-uppercase fw-700 mt-4 text-primary">
          {t(`myCourses`)}
        </p>
      </Col>
      <Col xs={12} className={hasHeader ? 'course-details' : 'course-list'}>
        <Table
          borderless={false}
          striped={false}
          height={700}
          columns={columns}
          data={data || []}
          subHeader={
            (hasHeader && sectionDetail && sectionDetail.length > 0 && (
              <span className="text-primary">
                {sectionDetail[0].courseName}
              </span>
            )) ||
            undefined
          }
        />
      </Col>
    </Row>
  );
};

export default CoursesInfo;
